import Grid from '../components/grid'
import ResourceItem from '../components/resource-item'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Page, Post } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'dark-resources-gallery' }>

export default function DarkResourcesGallery(block: BlockProps): ReactElement {
  const { title, subTitle } = block
  const resources = block?.resources as Post[]

  return (
    <Container>
      <Grid id="resources" className="bg-heading text-white p-8 md:p-12 lg:p-20">
        <div className="col-span-full sm:mb-4 md:mb-6 lg:mb-8 xl:mb-10 text-white flex flex-col justify-start items-start">
          <h5 className="text-white mb-1 lg:mb-2 opacity-50">{subTitle}</h5>
          <Text variant="headingLight" className="text-white">
            {title}
          </Text>

          <div className="bg-white h-[1px] w-full mt-6 md:mt-8" />
        </div>

        {resources.slice(0, 3).map((resource, idx) => (
          <ResourceItem key={`resource--key-${idx}`} resource={resource} />
        ))}
      </Grid>
    </Container>
  )
}
